import { render, staticRenderFns } from "./Home4.vue?vue&type=template&id=4b7e9b70&scoped=true&"
import script from "./Home4.vue?vue&type=script&lang=js&"
export * from "./Home4.vue?vue&type=script&lang=js&"
import style0 from "./Home4.vue?vue&type=style&index=0&id=4b7e9b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e9b70",
  null
  
)

export default component.exports